import { useQuery } from "@tanstack/react-query";
import { useEncounterCreationGate } from "../hooks/use-encounter-creation-gate";
import { SpecialityControllerApi } from "../services";
import { getConfigObject, useBaseContent } from "../utils/utils";

interface Props {
  xTENANTID?: string;
  searchString?: string;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Shrinivas Mandhare
 */
export const useSpecialtiesList = ({
  searchString,
  xTENANTID,
  enabled,
}: Props): useBaseContent<OptionData> => {
  const skip = useEncounterCreationGate();
  return useQuery({
    queryKey: ["Specialties-list", searchString, xTENANTID],
    refetchOnWindowFocus: false,
    enabled: (enabled ?? true) && !skip,
    queryFn: async () => {
      // * @param {number} [page]
      // * @param {number} [size]
      // * @param {string} [sortBy]
      // * @param {string} [searchString]
      // * @param {string} [sortDirection]
      // * @param {string} [xTENANTID]
      const api = new SpecialityControllerApi(getConfigObject());
      const response = await api.getAllSpecialities(
        undefined, // page
        undefined, // size
        undefined, // sortBy
        searchString, //searchString
        undefined, // sortDirection
        xTENANTID // xTENANTID
      );
      return response?.data;
    },
  });
};
